export default [
  {
    id: 'overview',
    name: 'Property Data',
    subsections: [
      { id: 'valuationRequest', name: 'Valuation Request' },
      { id: 'propertyValue', name: 'Property value' },
      { id: 'description', name: 'Description' },
      { id: 'marketHistory', name: 'Market history' },
      { id: 'build', name: 'Build' },
      { id: 'propertySize', name: 'Property size' },
      { id: 'plotInformation', name: 'Plot information' },
      { id: 'councilTax', name: 'Council tax' },
      { id: 'tenure', name: 'Tenure' },
      { id: 'floodRisk', name: 'Flood risk' },
      { id: 'epc', name: 'EPC' },
      { id: 'mobileCoverage', name: 'Mobile coverage' },
      { id: 'broadbandSpeed', name: 'Broadband speed' },
      { id: 'planningApplications', name: 'Planning applications' },
      { id: 'listedBuildings', name: 'Listed buildings' },
      { id: 'constructionMaterials', name: 'Construction materials' },
      { id: 'utilities', name: 'Utilities' },
      { id: 'propertyRestrictions', name: 'Restrictions and rights' },
      { id: 'coastalErosion', name: 'Coastal erosion' },
      { id: 'outdoorSpace', name: 'Outdoor space' },
      { id: 'treePreservationOrders', name: 'Tree preservation orders' },
      { id: 'airTrafficNoise', name: 'Air traffic noise' },
      { id: 'parking', name: 'Parking' },
    ],
  },
  {
    id: 'comparables',
    name: 'Comparables',
    subsections: [
      { id: 'sales', name: 'Sales' },
      { id: 'completed', name: 'Completed' },
      { id: 'lettings', name: 'Lettings' },
    ],
  },
  {
    id: 'localArea',
    name: 'Local area',
    subsections: [
      { id: 'education', name: 'Schools' },
      { id: 'transport', name: 'Transport' },
      { id: 'nearbyPlanningApplications', name: 'Nearby planning' },
      { id: 'nearbyListedBuildings', name: 'Nearby listed buildings' },
    ],
  },
  {
    id: 'gallery',
    name: 'Gallery',
    subsections: [
      { id: 'pastListingImages', name: 'Listing images' },
      { id: 'uploadedImages', name: 'Photos' },
      { id: 'videoAndVirtualTours', name: 'Video & virtual tours' },
    ],
  },
  {
    id: 'market',
    name: 'Market Data',
    subsections: [
      {
        id: 'sales',
        name: 'Sales',
        subsections: [
          { id: 'salesEstimatedPriceChange', name: 'Price change (sales)' },
          { id: 'salesAverageTimeOnMarket', name: 'Time on market (sales)' },
          { id: 'salesVolumeOfSoldProperties', name: 'Volume sold (sales)' },
          { id: 'salesAveragePricePerSqft', name: 'Price per sqft (sales)' },
        ],
      },
      {
        id: 'lettings',
        name: 'Lettings',
        subsections: [
          { id: 'lettingsEstimatedPriceChange', name: 'Price change (lettings)' },
          { id: 'lettingsAverageTimeOnMarket', name: 'Time on market (lettings)' },
          { id: 'lettingsVolumeOfLetProperties', name: 'Volume let (lettings)' },
          { id: 'lettingsAveragePropertyYield', name: 'Average yield (lettings)' },
        ],
      },
    ],
  },
  {
    id: 'about',
    name: 'About',
    subsections: [
      { id: 'agentBio', name: 'Agent bio' },
      { id: 'agencyBio', name: 'Branch bio' },
      { id: 'video', name: 'Video' },
      { id: 'testimonials', name: 'Testimonials' },
      { id: 'contact', name: 'Contact Information' },
    ],
  },
];
